import React from 'react'
import PageLayout from '../../../PageLayout'
import { EButton, EModal, EPageTitle, ETable } from '../../../libs/ui'
import { BsUpload } from 'react-icons/bs'
import { ECard } from '../../../libs/ui/src/Card/ECard'
import { Select, Skeleton, Switch, Text, Textarea, TextInput } from '@mantine/core'
import { MdEdit } from 'react-icons/md'
import useContentRepository from './hook/useContentRepository'
import { FaFilePdf } from 'react-icons/fa'
import moment from 'moment'

const ContentRepository = () => {
   const {
     loading,
     contentRepositoryData,
     contentRepositoryDetails,
     open,
     setOpen,
     handleChangeRepository,
     currentPage,
     setCurrentPage,
     itemsPerPage,
     totalRecords,
     prevPage,
     nextPage,
     category,
     roles,
     onchangeSingalContent,
     saveContentRepository,
     confirmOpen,
     setConfirmOpen,
     confirmPayload,
     setConfirmPayload,
     handleConfirmToggle,
     handleToggleRequest,
     handleCancelToggle,
     onCloseModal,
     search,
     setSearch,
     contentRepositoryAllData,
   } = useContentRepository();

const totalPages = Math.ceil(totalRecords / itemsPerPage);

let startPage = Math.max(1, currentPage - Math.floor(itemsPerPage / 2 / 2));
let endPage = Math.min(totalPages, startPage + itemsPerPage / 2 - 1);

if (endPage - startPage + 1 < itemsPerPage / 2) {
  if (currentPage <= Math.ceil(itemsPerPage / 2 / 2)) {
    endPage = Math.min(itemsPerPage / 2, totalPages);
  } else if (currentPage > totalPages - Math.floor(itemsPerPage / 2 / 2)) {
    startPage = Math.max(1, totalPages - itemsPerPage / 2 + 1);
  } else {
    startPage = Math.max(1, currentPage - Math.floor(itemsPerPage / 2 / 2));
    endPage = Math.min(
      totalPages,
      currentPage + Math.floor(itemsPerPage / 2 / 2)
    );
  }
}


  return (
    <PageLayout>
      <EPageTitle title="Content Repository" />
      <div className="flex justify-end w-full">
        <EButton
          className="btn-blue"
          rightIcon={<BsUpload />}
          onClick={() => setOpen(true)}
        >
          Add Content Repository
        </EButton>
      </div>
      <div className="mt-4">
        <ECard noHeader title="" customClass="overflow-auto">
          {!loading ? (
            <>
              {contentRepositoryAllData?.length > 0 ? (
                <div className="flex justify-end mb-4">
                <TextInput
                  size="md"
                  placeholder="Search Title"
                  value={search}
                  onChange={(e) => setSearch(e?.target?.value)}
                  className="w-1/3"
                />
              </div>
              ) : null  
              }
              
              {contentRepositoryData?.length > 0 ? (
                <>
                  <ETable>
                    <thead>
                      <tr>
                        <th>S No.</th>
                        <th>Repository Title</th>
                        <th>Repository Description</th>
                        <th>Catagory</th>
                        <th>File</th>
                        <th>Role</th>
                        <th>created on</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {contentRepositoryData?.map((item: any, index) => {
                        return (
                          <tr>
                            <td>
                              {search
                                ? index + 1
                                : currentPage * itemsPerPage + (index + 1)}
                            </td>
                            <td>{item?.content_Title}</td>
                            <td>{item?.content_Description}</td>
                            <td>{item?.category_Name}</td>
                            <td>
                              <a
                                className="flex justify-center"
                                href={item?.content_Url}
                                target="_blank"
                              >
                                <FaFilePdf size={20} />
                                {/* {item?.content_Url?.split("/").pop()} */}
                              </a>
                            </td>
                            <td>{item?.role_Name}</td>
                            <td>
                              {moment(item?.created_On).format("DD-MM-YYYY")}
                            </td>
                            <td className="w-32">
                              <div className="flex items-center ">
                                <Switch
                                  checked={item?.is_Active === 1 ? true : false}
                                  size="lg"
                                  onLabel="Active"
                                  offLabel="Inactive"
                                  onChange={() =>
                                    handleToggleRequest(
                                      item?.content_Repository_Id,
                                      item?.is_Active === 1
                                    )
                                  }
                                />
                                {item?.is_Active === 0 ? null : (
                                  <MdEdit
                                    onClick={() =>
                                      onchangeSingalContent(
                                        item?.content_Repository_Id
                                      )
                                    }
                                    className="inline ml-4 mt-4 text-xl text-blue-600 cursor-pointer"
                                  />
                                )}
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </ETable>

                  <div className="text-end mt-2">
                    {/* Pagination controls */}
                    <EButton
                      className="btn-blue"
                      onClick={prevPage}
                      disabled={currentPage === 0}
                    >
                      Previous
                    </EButton>

                    {/* Render first page */}
                    {startPage > 1 && (
                      <>
                        <EButton
                          onClick={() => setCurrentPage(0)}
                          className="btn-light ml-2"
                        >
                          1
                        </EButton>
                        {startPage > 2 && <span className="ml-2">...</span>}
                      </>
                    )}

                    {/* Render page numbers */}
                    {Array.from(
                      { length: endPage - startPage + 1 },
                      (_, index) => startPage + index
                    ).map((page) => (
                      <EButton
                        key={page}
                        onClick={() => setCurrentPage(page - 1)}
                        className={
                          currentPage === page - 1
                            ? "btn-blue ml-2"
                            : "btn-light ml-2"
                        }
                      >
                        {page}
                      </EButton>
                    ))}

                    {/* Render last page */}
                    {endPage < totalPages && (
                      <>
                        {endPage < totalPages - 1 && (
                          <span className="ml-2">...</span>
                        )}
                        <EButton
                          onClick={() => setCurrentPage(totalPages - 1)}
                          className={
                            currentPage === totalPages - 1
                              ? "btn-blue ml-2"
                              : "btn-light ml-2"
                          }
                        >
                          {totalPages}
                        </EButton>
                      </>
                    )}

                    <EButton
                      className="btn-blue ml-2"
                      onClick={nextPage}
                      disabled={
                        contentRepositoryData?.length < itemsPerPage ||
                        currentPage === totalPages - 1
                      }
                    >
                      Next
                    </EButton>
                  </div>
                </>
              ) : (
                <div className="text-blue-600 text-sm mt-2 mb-2 text-center">
                  <Text fz="md">No record Found!</Text>
                </div>
              )}
            </>
          ) : (
            <Skeleton height={220} radius="md" />
          )}
        </ECard>
      </div>

      <EModal
        size="lg"
        title={`${
          contentRepositoryDetails?.content_Repository_Id ? "Update" : "Add"
        } Content Repository`}
        isOpen={open}
        onClose={onCloseModal}
        setIsOpen={onCloseModal}
      >
        <div className="w-full flex flex-col gap-4">
          <div className="w-full flex">
            <TextInput
              size="md"
              required
              label="Title"
              className="w-2/3 mr-4"
              value={contentRepositoryDetails?.content_Title}
              onChange={(e) =>
                handleChangeRepository({
                  name: "content_Title",
                  value: e?.target?.value,
                })
              }
            />
            <Select
              size="md"
              required
              label="Category"
              className="w-2/3"
              placeholder="Select"
              value={contentRepositoryDetails?.content_Category_Id}
              data={category?.map((e: any) => {
                return {
                  value: String(e?.content_Category_Id),
                  label: e?.category_Name,
                };
              })}
              onChange={(e: any) =>
                handleChangeRepository({
                  name: "content_Category_Id",
                  value: e,
                })
              }
            />
          </div>

          <div className="w-full flex">
            <TextInput
              size="md"
              required
              label="Content URL"
              className="w-2/3 mr-4"
              value={contentRepositoryDetails?.content_Url}
              onChange={(e) =>
                handleChangeRepository({
                  name: "content_Url",
                  value: e.target.value,
                })
              }
            />

            <Select
              size="md"
              required
              label="Role"
              className="w-2/3"
              placeholder="Select"
              value={contentRepositoryDetails?.content_For_Role_Id}
              data={roles
                ?.filter((e: any) => [2, 3, 10, 11]?.includes(e.role_Id))
                ?.map((e: any) => {
                  return {
                    value: String(e?.role_Id),
                    label: e?.role_Name,
                  };
                })}
              onChange={(e: any) =>
                handleChangeRepository({
                  name: "content_For_Role_Id",
                  value: e,
                })
              }
            />
          </div>

          <Textarea
            size="md"
            required
            label="Description"
            value={contentRepositoryDetails?.content_Description}
            onChange={(e) =>
              handleChangeRepository({
                name: "content_Description",
                value: e.target.value,
              })
            }
          />
        </div>
        <div className="flex justify-end w-full mt-6">
          <EButton
            className="btn-blue"
            onClick={() =>
              saveContentRepository({
                type: contentRepositoryDetails?.content_Repository_Id
                  ? "Update"
                  : "insert",
                status: "active",
              })
            }
          >
            Submit
          </EButton>
        </div>
      </EModal>

      {/* Confirmation modal for toggling active/inactive */}
      <EModal
        size="sm"
        title="Confirm"
        isOpen={confirmOpen}
        onClose={handleCancelToggle}
        setIsOpen={handleCancelToggle}
      >
        <div className="py-4">
          <p>
            Are you sure you want to{" "}
            <strong>
              {confirmPayload?.status === "active" ? "Activate" : "Deactivate"}
            </strong>{" "}
            this Repository?
          </p>
        </div>
        <div className="flex justify-end gap-2 mt-4">
          <EButton className="btn-light" onClick={handleCancelToggle}>
            Cancel
          </EButton>
          <EButton className="btn-blue" onClick={handleConfirmToggle}>
            Confirm
          </EButton>
        </div>
      </EModal>
    </PageLayout>
  );
}

export default ContentRepository